import { useQuery } from '@tanstack/react-query'
import axios from '@/lib/axios'
import * as endpoints from '@/endpoints'

export const useNotificationsQuery = () =>
    useQuery({
        queryKey: ['notifications'],
        queryFn: () => axios.get(endpoints.NOTIFICATIONS).then((r) => r.data),
        staleTime: 1000 * 30
    })
